import { render, staticRenderFns } from "./PurchasePressPlanInput.vue?vue&type=template&id=1030a7d2&"
import script from "./PurchasePressPlanInput.vue?vue&type=script&lang=js&"
export * from "./PurchasePressPlanInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports